import {T} from 'Actions/translate';
export default {
    auth: {
        code: {},
        adminUser: {},
        mobileValid: {},
    },
    bind: {
        customerUser: {},
        unBind: {},
        codeValid: {},
        authCode: {},
        emailValid: {},
    },
    register: {
        registerUser: {},
        provinceList: {},
        shipToCityList: {},
        billToCityList: {},
        emailValidRegister: {},
    },
    order: {
        shipTo: [],
        supplyCenter: {},
        productLoadingMore: false,
        searchProductLoadingMore: false,
        recommendedProductLoadingMore: false,
        productAbyss: false,
        searchValue: '',
        productList: [],
        productListLoaded: false,
        searchProductList: [],
        searchProductListLoaded: false,
        recommendedProductList: [],
        recommendedProductListLoaded: false,
        pageSize: 10,
        categoryList: {},
        shipToSelected: {},
        cartList: {},
        changeShipList: {},
        eOneInventoryList: {},
        cartPrice: {},
        switchChoosePrice: '',
        cartCount: 0,
        previewOrder: {},
        tmProductList: [],
        otherShipToNumber: '',
        quoteInfor: {},
        quoteCustomerInfor: {},
        searchHistoryList: {},
        categroySelected: {
            key: 0,
            value: T('allProduct'),
        },
        cartActivity: {},
        noScOrderResult: {},
    },
    customer: {
        detachedFlag: false,
        showOtherCustomerButton: false,
        isLastPage: false,
        customerList: [],
        b2bPlatformShipToList: [],
    },
    localData: {},
    replenishment: {
        replenishmentStockList: [],
        replenishmentSCList: [],
        f1CartCount: 0,
        f1CartList: [],
        f1CartSelectedLotList: [],
        f1OrderList: {},
        f1OrderDetails: {},
        stockLoadingMore: false,
        stockAbyss: false,
        stockListLoaded: false,
        replenishmentLoadingMore: false,
        replenishmentAbyss: false,
        replenishmentListLoaded: false,
        submitF1Order: {},
        skuReplenishmentDetail: {},
        skuInventoryDetails: [],
        tabActive: 0,
        searchfields: {
            queryKey: '',
        },
        timeRangeOptions: [],
    },
    inventoryQuery: {
        inventoryQueryList: [],
        inventoryQueryListLoaded: false,
        inventoryQueryAbyss: false,
        productManagementSCList: [],
        productManagementList: [],
        productManagementListLoaded: false,
        pageSize: 10,
        productManagementAbyss: false,
    },
    // taskManagement: {
    //     assignmentCustomerList: [],
    //     assignmentCustomerListLoaded: false,
    //     pageSize: 10,
    //     assignmentCustomerAbyss: false,
    // },
    stManagement: {
        stManagementList: [],
        applySupplyCenterList: [],
        transportMethodList: [],
        taskDetailsSearchfields: {
            queryKey: '',
        },
    },
    userCenter: {
        myOrderCount: {},
        scHostInfor: {},
        personalInfor: {},
        backupList: [],
        SCList: [],
        alphaList: [],
        inventoryInfor: {},
        systemNotification: [],
    },
    allApply: {
        allApplyList: [],
        tabActive: 0,
        searchfields: {
            queryKey: '',
        },
        allApplyDetailsList: [],
        allApplyListLoaded: false,
        allApplyLoadingMore: false,
        allApplyAbyss: false,
    },
    noScOrder: {
        shipToInforOfApplyChange: {},
        cmgtOfSkuInfor: {},
        batchAddcartCount: 0,
    },
};
